import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=da3ce7ce&scoped=true"
import script from "./bottom.vue?vue&type=script&lang=js"
export * from "./bottom.vue?vue&type=script&lang=js"
import style0 from "./bottom.vue?vue&type=style&index=0&id=da3ce7ce&prod&scoped=true&lang=css"
import style1 from "./bottom.vue?vue&type=style&index=1&id=da3ce7ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d97cc52897b1b5edd1ee8818c6a75fc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3ce7ce",
  null
  
)

export default component.exports